import axios, { type AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios'
import { type ApiResponse } from '../../models/api/api-response'
import { type AppError } from '../../models/api/app-error'

export const callExternalApi = async (options: {
  config: AxiosRequestConfig
}): Promise<ApiResponse> => {
  try {
    const response: AxiosResponse = await axios(options.config)
    const { data } = response

    if (data.error != null) {
      return {
        error: data.error
      }
    } else {
      return { data }
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError

      const { response } = axiosError

      let errorMessage = 'http request failed'

      if (response?.statusText != null) {
        errorMessage = response.statusText
      }

      if (axiosError.message != null) {
        errorMessage = axiosError.message
      }

      if (response?.data != null && (response?.data as AppError).message != null) {
        errorMessage = (response.data as AppError).message
      }

      return {
        error: {
          message: errorMessage,
        },
      }
    }

    return {
      error: {
        message: (error as Error).message,
      },
    }
  }
}
